import { FC } from "react";
import { TAlertTitleProps } from "./Alert.config";
import { TextSubtitle } from "../../typography/TextSubtitle";
import { cn } from "@/ui/lib";
import { getAlertCopyColumnClass } from "./Alert.utils";

export const AlertTitle: FC<TAlertTitleProps> = ({ title, asset }) => (
  <div
    data-component="AlertTitle"
    className={cn(
      "row-start-1",
      getAlertCopyColumnClass(asset),
    )}
  >
    <TextSubtitle size={2} isResponsive={false} color="inherit">{ title }</TextSubtitle>
  </div>
);
